import React, { useContext, useState } from 'react';
import Label_language from "../../language";
import { ConfigProvider, Upload, Layout } from 'antd';
import { Card, } from 'react-bootstrap';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import styled from 'styled-components';
import { Button, Row, Col, Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '../../ui/ot'
import { useSearchParams, useNavigate } from "react-router-dom";

const label_language = Label_language.oms.children.online_order_management
const { ConfigContext } = ConfigProvider;
const Upload_style = styled(Upload)`
& .upload-list-inline .ant-upload-list-item {
  float: left;
  width: 200px;
  margin-inline-end: 8px;
}

& .ant-upload-rtl.upload-list-inline .ant-upload-list-item {
  float: right;
}
`
const App = () => {
    const configContext = useContext(ConfigContext);
    const language = configContext.locale.locale
    const [searchParams] = useSearchParams()
    const { classify_structure_type_parent_id } = Object.fromEntries([...searchParams])
    return (
        <Layout
            style={{
                minHeight: '100vh',

            }}
        >
            <Upload_ot
                language={label_language}
                classify_structure_type_parent_id={classify_structure_type_parent_id}
            />
        </Layout>
    );
}
export default App;
const Upload_ot = ({
    classify_structure_type_parent_id = 0
}) => {
    const [file_list, set_file_list] = useState([])
    return (<>
        <Card>
            <Card.Body>
                <Card className="my-1 align-top" style={{ padding: '0rem', borderColor: "#6e6e6e" }}>
                    <Card.Header
                        className="justify-content-center align-items-center"
                        style={{ borderColor: "#677696", background: "#EDFDF9", }}
                    >
                        <span style={{ color: "black", fontSize: '1.2rem' }}>{'手機上傳圖片'}</span>
                    </Card.Header>
                    <Card.Body style={{ height: '762px', overflowY: 'scroll' }}>
                        <Row gutter={[24, 24]}>
                            <Col span={24}>
                                <Upload
                                    listType="picture"
                                    customRequest={e => {
                                        let payload = new FormData();
                                        payload.append('inputFile', e.file);
                                        payload.append('token', 'cbj_tech');
                                        payload.append('classify_structure_type_parent_id', classify_structure_type_parent_id)
                                        axios
                                            .post("media/api/file/upload_phone", payload, {
                                                headers: {
                                                    'Content-Type': 'multipart/form-data'
                                                },
                                                maxContentLength: 5 * 1024 * 1024 * 1024,  
                                                maxBodyLength: 5 * 1024 * 1024 * 1024         
                                            })
                                            .then(response => {
                                                e.onSuccess({
                                                    ...e.file,
                                                    status: 'success'
                                                })
                                                // set_file_list(prev=>prev.map(map_item=>(
                                                //   map_item.uid===e.file.uid?
                                                //   {
                                                //     ...map_item,
                                                //     status:'success'
                                                //   }
                                                //   :map_item
                                                // )))
                                            })
                                    }}
                                >
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger>
                                                <Button type={'primary'}>
                                                    <UploadOutlined style={{ textAlign: 'text-top' }} />
                                                    點此上傳訂單圖片
                                                </Button>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <p>請由此開始進行操作</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>

                                </Upload>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Card.Body>
        </Card>
    </>)
}